import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LineFeatureFieldConfig, LineFeatureFieldConfigRequest } from '../models/generated/ziroModels';

@Injectable({
  providedIn: 'root',
})
export class LineFeatureConfigResource {
  protected http = inject(HttpClient);

  protected _baseUrl = '/services/cisco/field-configs/line-features';

  post(body: LineFeatureFieldConfigRequest): Observable<LineFeatureFieldConfig> {
    return this.http.post<LineFeatureFieldConfig>(this._baseUrl, body);
  }
}
